'use client';

import { c as _c } from "react/compiler-runtime";
import type { RefObject } from 'react';
import { useCallback, useState } from 'react';
export type VideoPlaybackState = 'idle' | 'starting' | 'playing' | 'waiting' | 'paused' | 'ended' | 'error';
export const useVideoPlaybackState = selectedIndexRef => {
  const $ = _c(22);
  const [state, setState] = useState("idle");
  let t0;
  if ($[0] !== selectedIndexRef) {
    t0 = (index, nextState) => {
      if (index !== selectedIndexRef.current) {
        return;
      }
      setState(nextState);
    };
    $[0] = selectedIndexRef;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const updateState = t0;
  let t1;
  if ($[2] !== updateState) {
    t1 = index_0 => updateState(index_0, "playing");
    $[2] = updateState;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const handleVideoPlaying = t1;
  let t2;
  if ($[4] !== updateState) {
    t2 = index_1 => updateState(index_1, "paused");
    $[4] = updateState;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  const handleVideoPause = t2;
  let t3;
  if ($[6] !== updateState) {
    t3 = index_2 => updateState(index_2, "waiting");
    $[6] = updateState;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  const handleVideoWaiting = t3;
  let t4;
  if ($[8] !== updateState) {
    t4 = index_3 => updateState(index_3, "waiting");
    $[8] = updateState;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  const handleVideoSeeking = t4;
  let t5;
  if ($[10] !== updateState) {
    t5 = index_4 => updateState(index_4, "starting");
    $[10] = updateState;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  const handleVideoSeeked = t5;
  let t6;
  if ($[12] !== updateState) {
    t6 = index_5 => updateState(index_5, "error");
    $[12] = updateState;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  const handleVideoError = t6;
  let t7;
  if ($[14] !== handleVideoError || $[15] !== handleVideoPause || $[16] !== handleVideoPlaying || $[17] !== handleVideoSeeked || $[18] !== handleVideoSeeking || $[19] !== handleVideoWaiting || $[20] !== state) {
    t7 = {
      videoPlaybackState: state,
      setVideoPlaybackState: setState,
      handleVideoPlaying,
      handleVideoPause,
      handleVideoWaiting,
      handleVideoSeeking,
      handleVideoSeeked,
      handleVideoError
    };
    $[14] = handleVideoError;
    $[15] = handleVideoPause;
    $[16] = handleVideoPlaying;
    $[17] = handleVideoSeeked;
    $[18] = handleVideoSeeking;
    $[19] = handleVideoWaiting;
    $[20] = state;
    $[21] = t7;
  } else {
    t7 = $[21];
  }
  return t7;
};